import { Popper, List, ListItem, ListItemAvatar, ListItemText, Paper, Divider, Button, Tooltip } from '@mui/material';
import { Link, useHistory } from 'react-router-dom';
import styles from './styles.module.css';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
// import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import PersonIcon from '@mui/icons-material/Person';
import { ROUTES, STORAGE_KEYS } from 'const';
import AuthService from 'services/AuthService';
import ShopSettingsService from 'services/ShopSettingsService';
import { ShopContext } from 'Context/ShopContext';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';

export default function AccountSwitchDialog(props) {
  const { t: tCommon } = useTranslation('common');
  const { accounts, anchorEI, isOpen } = props;
  const { setShop, shop } = useContext(ShopContext);
  const history = useHistory();
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [searchText, setSearchText] = useState('');
  const shopId = localStorage.getItem(STORAGE_KEYS.SHOP_ID);

  const loadShopProfile = async () => {
    const shopProfile = await ShopSettingsService.loadShopProfile();
    setShop(shopProfile);
  };

  const handleSwitchAccount = async (account) => {
    localStorage.removeItem(STORAGE_KEYS.SHOP_NAME);
    localStorage.setItem(STORAGE_KEYS.SHOP_ID, account.id);
    await loadShopProfile();
    window.location.reload();
    history.push(ROUTES.HOME);
  };
  const logoutBtnPressed = async (e) => {
    await AuthService.logout();
    window.location.reload();
  };

  const sortedAccounts = useCallback(() => (accounts || []).sort((a, b) => a.id - b.id), [accounts]);

  const handleSearch = (value) => {
    setSearchText(value);
    const filterResponse = accounts
      ? accounts.filter(
          (acc) => acc.shop_name.toLowerCase().includes(value.toLowerCase()) || acc.id.toString().includes(value)
        )
      : [];
    setFilteredAccounts(filterResponse);
  };

  useEffect(() => {
    const resp = sortedAccounts();
    setFilteredAccounts(resp);
  }, [sortedAccounts]);

  return (
    <Popper
      id="spring-popper"
      open={isOpen}
      anchorEl={anchorEI}
      placement="bottom"
      style={{ width: 300, zIndex: 999999999 }}
    >
      <Paper elevation={15} style={{ maxHeight: 400, overflowY: 'scroll' }}>
        <List>
          {shopId && shop && (
            <>
              <ListItem button key={shopId} className={styles.selectedProfile}>
                <ListItemAvatar key={shopId}>
                  <PersonIcon />
                </ListItemAvatar>
                <ListItemText primary={shop.shop_name} />
              </ListItem>
              <Divider component="li" />
              {(accounts || []).length > 4 && (
                <ListItem
                  className={styles.selectedProfile}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <div className={styles.searchSec}>
                    <input
                      type="text"
                      value={searchText}
                      onChange={(e) => {
                        handleSearch(e.target.value);
                      }}
                      className={styles.searchInput}
                      placeholder={tCommon('search shop')}
                    />
                    <Tooltip title={tCommon('Search')} placement="bottom">
                      <SearchIcon className={styles.searchIcon} />
                    </Tooltip>
                  </div>
                </ListItem>
              )}
              <Divider component="li" />
              {filteredAccounts &&
                filteredAccounts.map((account) => {
                  return (
                    <div key={account.id}>
                      {account.id.toString() !== shopId && (
                        <>
                          <ListItem button onClick={() => handleSwitchAccount(account)} key={account.shop_name}>
                            <ListItemAvatar key={account.id}>
                              <PersonIcon />
                            </ListItemAvatar>
                            <ListItemText primary={account.shop_name} />
                          </ListItem>
                          <Divider component="li" />
                        </>
                      )}
                    </div>
                  );
                })}
            </>
          )}
          {/* <ListItem>
            <Button
              variant="contained"
              size="small"
              fullWidth
              className={styles.actionBtn}
              style={{
                backgroundColor: '#605ca8',
                padding: '4px',
                color: '#fff',
              }}
              onClick={toggleAddShopDialog}
            >
              <AddBusinessIcon
                fontSize="small"
                className={styles.addShopIcon}
              />
              New Shop
            </Button>
          </ListItem> */}
          <ListItem>
            <Link to={ROUTES.LOGIN} style={{ textDecorationColor: 'transparent', width: '100%' }}>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                fullWidth
                className={styles.actionBtn}
                onClick={logoutBtnPressed}
              >
                <PowerSettingsNewIcon fontSize="small" className={styles.actionBtnIcon} />
                {tCommon('Logout')}
              </Button>
            </Link>
          </ListItem>
        </List>
      </Paper>
    </Popper>
  );
}
